import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '游戏分类', path: '/category' },
  { name: '游戏资讯', path: '/articles' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-200/50'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 cursor-pointer group"
          >
            <span className="font-heading text-xl font-bold text-primary-500 tracking-wider">
              GALAGAME
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`relative px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? 'text-primary-500 bg-primary-500/10'
                      : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-200/50'
                  }`}
                >
                  {link.name}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/"
              className="px-5 py-2 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即注册
            </Link>
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-300 hover:text-foreground-100 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          isMobileOpen ? 'max-h-[400px]' : 'max-h-0'
        }`}
      >
        <div className="bg-background-100/95 backdrop-blur-md border-b border-background-200/50 px-4 py-4 space-y-1">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                  isActive
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-200/50'
                }`}
              >
                {link.name}
              </Link>
            );
          })}
          <Link
            to="/"
            className="block text-center px-5 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all duration-200 mt-3 cursor-pointer"
          >
            立即注册
          </Link>
        </div>
      </div>
    </nav>
  );
}